import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root' // optional but recommended in Angular services
})
export class CashLogsService {
  private readonly baseUrl = environment._URL_ + 'bet';

  constructor(
    private api: ApiService,
  ) {}

  // Get Cash Logs
  getCashLogs(query?: any) {
    return this.api.get(`${this.api.path}/logs`, query);
  }

  // Get Log Status
  getLogStatus() {
    return this.api.get(`${this.api.path}/logs/logStatus`);
  }

  // ✅ Get All VIP Levels
  getVipLevels(query?: any) {
    return this.api.get(`${this.api.path}/get/all/levels`, query);
  }
    getvipresellerlevels(resellerId: number, query?: any) {
        return this.api.get(this.api.path + "/get/resellerVipLevels/" + resellerId +"/" , query);
    }
  // ✅ Delete VIP Level by ID
  deleteVipLevel(id: string) {
    return this.api.delete(`${this.api.path}/delete/level/${id}`).toPromise();
  }
  deleteVipShopsLevel(id: string) {
    return this.api.delete(`${this.api.path}/delete/resellerVipLevel/${id}`).toPromise();
  }

  // ✅ Update VIP Level by ID
  updateVipLevel(id: string, data: any) {
    return this.api.post(`${this.api.path}/update/level/${id}`, data).toPromise();
  }
  updateVipShopsLevel(id: string, data: any) {
    return this.api.post(`${this.api.path}/update/resellerVipLevel/${id}`, data).toPromise();
  }

  // ✅ Create a New VIP Level
  createVipLevel(data: any) {
    return this.api.post(`${this.api.path}/create/level`, data).toPromise();
  }
    // ✅ Create a New VIP Level
    createVipShopsLevel(data: any) {
      return this.api.post(`${this.api.path}/resellerVipLevels/create`, data).toPromise();
    }
}
